/**
 * React kontext s REST klientom (S11, F4AI-17).
 *
 * Stránky nedostávajú `api` ako prop, ale z kontextu — v appke sedí
 * defaultná inštancia (`createApi()` s `VITE_GATEWAY_URL`), v testoch
 * obalíme strom `ApiProvider`-om s mock klientom. Je to to isté ako
 * injectnutý `fetch`, len o úroveň vyššie, takže testy nemusia
 * mockovať `globalThis.fetch` vôbec.
 */
import { createContext, useContext, type JSX, type ReactNode } from 'react';

import { api as defaultApi, type Api } from './client.js';

const ApiContext = createContext<Api>(defaultApi);

export function ApiProvider({ client, children }: { client: Api; children: ReactNode }): JSX.Element {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

/** vrhá klient z kontextu (default = live gateway klient) */
export function useApi(): Api {
  return useContext(ApiContext);
}

export { ApiContext };
